import useSession from "../../../effects/useSession";

export function canUseTerminalCommands(session:  ({id: string | null, type: string, attributes: {Email: string, Enabled: boolean, FirstName: string, Group: string} & {TempPassword?: boolean | undefined, LastName?: string | undefined, PreferredName?: string | undefined, Company?: string | undefined, Department?: string | undefined, Phone?: string | undefined, LastLogin?: string | undefined, Password?: string | undefined}} & {createdAt?: string | undefined, updatedAt?: string | undefined}) | undefined): boolean {
    const email = session?.attributes?.Email ?? undefined
    if(email === undefined){
        return false
    }
    // have michael@datameshgroup.com initially to allow myself to use terminal commands,
    // once we're satisfied with this behaviour, we can change this access control and remove myself from the list.
    return (session?.attributes?.Group == "Administator") || (email === "michael@datameshgroup.com")
}
